'use client';

import { getCookie } from 'eco-design-micro/EcoStat/utils/cookieFn';

// B 端 token
export const getBToken = () => {
    return localStorage.getItem('bh-token');
};
// B 端 token
export const setBToken = (token: string) => {
    if (token) {
        return localStorage.setItem('bh-token', token);
    }
};
// C 端 token
export const getCToken = () => {
    try {
        const userInfo = decodeURIComponent(getCookie('userInfo'));
        return JSON.parse(userInfo).token;
    } catch (err) {
        console.log('getToken error', err);
        return '';
    }
};
// C 端 token
export const setCToken = (token: string) => {
    if (token) {
        return localStorage.setItem('token', token);
    }
};
